import { Box, Skeleton, Typography } from "@mui/material";
import { isTruthy } from "helpers/methods";
import { parseHTML } from "screens/Tickets/ViewTicket/Components/CommentEditor";
import TicketAttachments from "screens/Tickets/ViewTicket/Components/Attachments";
import {
  cardSx,
  cardTitleSx,
  descriptionBodySx,
  sectionLabelSx,
} from "../ViewTicket.styles";

interface CustomProps {
  ticketDetails: any;
  isLoading: boolean;
}

/**
 * Description card: what the reporter wrote, followed by whatever they attached
 * when raising the ticket.
 */
const TicketReporterDetails = ({ ticketDetails, isLoading }: CustomProps) => {
  const attachments: string[] = ticketDetails?.docUrls ?? [];

  return (
    <Box sx={cardSx}>
      <Typography component="h2" sx={cardTitleSx}>
        Description
      </Typography>

      {isLoading ? (
        <>
          <Skeleton animation="wave" variant="text" height={18} />
          <Skeleton animation="wave" variant="text" height={18} width="80%" />
        </>
      ) : (
        <Typography component="div" sx={descriptionBodySx}>
          {isTruthy(ticketDetails?.description) &&
            parseHTML(ticketDetails.description)}
        </Typography>
      )}

      {!isLoading && attachments.length > 0 && (
        <>
          <Typography component="span" sx={sectionLabelSx}>
            ATTACHMENTS
          </Typography>
          <TicketAttachments files={attachments} />
        </>
      )}
    </Box>
  );
};

export default TicketReporterDetails;
